export default __webpack_public_path__ + "img/super-saturday-vaxathon-logo.svg";